import ReactDOM from 'react-dom';
const DocumentHead = ({
  head,
  children
}) => {
  return /*#__PURE__*/ReactDOM.createPortal(children, head);
};

/* eslint-disable-next-line hubspot-dev/no-default-props-assignment */
DocumentHead.defaultProps = {
  head: document.head
};
export default DocumentHead;